
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierContact.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierContact.ts

import {Supplier } from "./Supplier";
import {Contact } from "./Contact";
export class SupplierContact {

  // int SupplierId
  public SupplierId: number=0;

  // int ContactId
  public ContactId: number=0;

  // byte? IsReferent
  public IsReferent?: number=null;

  // byte? CreateAccount
  public CreateAccount?: number=null;

  // Supplier Supplier
  public Supplier: Supplier=null;

  // Contact Contact
  public Contact: Contact=null;
}